import { Turbo } from "@hotwired/turbo-rails";

// turbo_stream.action(:redirect, target: "/some-path")
Turbo.StreamActions.redirect = function () {
  Turbo.visit(this.target);
};
